import React from 'react';
import { getAbbreviatedUnit } from 'helpers/unitsAbbreviation';
import { formatDateToShortMonthDayYearTime } from 'utilities/dateHelpers';
import { mapToStandardColor } from 'constants/colors';
import Tag from 'screens/Applications&WorkOrders/StepsLayout/Components/DetailsStep/components/TagsSection/components/Tag';
import {
  InfoRow,
  NOT_AVAILABLE,
  usePlanTabContentStyle,
  formatArea,
  PlanDetails
} from './PlanDetailPanel.helpers';

export interface PlanDetailsTabProps {
  plan: PlanDetails;
  cropName?: string;
  cropSeasonNames: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allTags: any;
}

const PlanDetailsTab: React.FC<PlanDetailsTabProps> = ({
  plan,
  cropName,
  cropSeasonNames,
  allTags
}) => {
  const tabContentStyle = usePlanTabContentStyle();

  return (
    <div className="details-tab-container" style={tabContentStyle}>
      <div
        className="px-6 py-8 min-w-0"
        data-testid="plan-detail-tab-panel-details"
        style={{ paddingBottom: 72 }}
      >
        {/* Tags render as their own full-width row, not squeezed into one
          column, matching Applications/Work Orders' DetailsTab. Reads left
          column top-to-bottom then right column, not row-by-row. */}
        <div className="details-field-list">
          <div className="details-columns-row">
            <div className="details-left-col">
              <InfoRow label="Planned Area">
                {formatArea(plan?.estimatedAreaValue)}{' '}
                {getAbbreviatedUnit(plan?.estimatedAreaUnit)}
              </InfoRow>
              <InfoRow label="Crop">{cropName || NOT_AVAILABLE}</InfoRow>
              <InfoRow label="Crop Season(s)">
                {cropSeasonNames.length > 0
                  ? cropSeasonNames.join(', ')
                  : NOT_AVAILABLE}
              </InfoRow>
            </div>
            <div className="details-right-col">
              {/* Full record name, in case a long Plan name is truncated at the
                panel's header title. */}
              <InfoRow label="Plan ID">{plan?.name || NOT_AVAILABLE}</InfoRow>
              <InfoRow label="Record Created">
                {plan?.createdDateEpoch && plan.createdDateEpoch > 0
                  ? formatDateToShortMonthDayYearTime(plan.createdDateEpoch)
                  : NOT_AVAILABLE}
              </InfoRow>
            </div>
          </div>
          <InfoRow label="Tags">
            {plan?.flagIds && plan.flagIds.length > 0 ? (
              <div className="flex flex-wrap gap-2 flex-1 min-w-0">
                {plan.flagIds
                  .map(flagId =>
                    (allTags as
                      | Array<{ id: string; name: string; color: string }>
                      | undefined)?.find(tag => tag.id === flagId)
                  )
                  .filter(Boolean)
                  .map(tag => {
                    const colorMapping = mapToStandardColor(tag!.color);
                    return (
                      <Tag
                        key={tag!.id}
                        name={tag!.name}
                        backgroundColor={colorMapping.background}
                        textColor={colorMapping.text}
                        fontSize="12px"
                        paddingRight="8px"
                        paddingLeft="8px"
                      />
                    );
                  })}
              </div>
            ) : (
              NOT_AVAILABLE
            )}
          </InfoRow>
        </div>
      </div>
    </div>
  );
};

export default PlanDetailsTab;
